export default {
      id: "globe-usage",
      viewBox: "0 0 61 61",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#globe",
      toString: function () {
        return this.url;
      }
    }